<p-toast></p-toast>
<p-confirmDialog header="Atenção" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="rd">
  <div class="rd-topo">
    <div class="rd-titulo">
      <h1>Relatórios dinâmicos</h1>
      <p>Modelos em JSON sobre fontes SQL escritas pelos técnicos. Os relatórios Jasper continuam na Central de Relatórios.</p>
    </div>
    <button pButton type="button" class="p-button-outlined p-button-secondary" label="Categorias" icon="pi pi-sitemap" (click)="abrirCategorias()"></button>
    <ng-container *ngIf="podeSql">
      <button pButton type="button" class="p-button-outlined p-button-secondary" label="Importar JRXML" icon="pi pi-upload" (click)="arquivoJrxml.click()"></button>
      <input #arquivoJrxml type="file" accept=".jrxml,.xml" hidden (change)="importarJrxml($event)" />
      <button pButton type="button" class="p-button-outlined p-button-secondary" label="Nova fonte" icon="pi pi-database" (click)="novaFonte()"></button>
    </ng-container>
    <button pButton type="button" class="p-button-outlined" label="Criar com IA" icon="pi pi-bolt" *ngIf="podeIncluir" (click)="criarComIa()"></button>
    <button pButton type="button" label="Novo modelo" icon="pi pi-plus" *ngIf="podeIncluir" (click)="abrirNovoModelo()"></button>
  </div>

  <div class="rd-abas" role="tablist">
    <button type="button" role="tab" [attr.aria-selected]="aba === 'modelos'" [class.ativa]="aba === 'modelos'" (click)="aba = 'modelos'">
      Modelos {{ modelos.length }}
    </button>
    <button type="button" role="tab" [attr.aria-selected]="aba === 'fontes'" [class.ativa]="aba === 'fontes'" [disabled]="!podeSql" (click)="aba = 'fontes'"
      [pTooltip]="podeSql ? null : 'Só quem tem a permissão de editar SQL (.S.) vê as fontes'">
      Fontes SQL {{ podeSql ? fontes.length : '' }} <i class="pi pi-lock"></i>
    </button>
  </div>

  <p-progressBar *ngIf="carregando" mode="indeterminate" [style]="{ height: '4px' }"></p-progressBar>

  <div class="rd-corpo" *ngIf="aba === 'modelos'">
    <section class="rd-categorias" aria-label="Categorias">
      <button type="button" class="rd-todas" [class.ativa]="!categoriaSelecionada" (click)="categoriaSelecionada = null">
        <span>Todas</span><span>{{ modelos.length }}</span>
      </button>
      <p-tree *ngIf="arvore.length" [value]="arvore" selectionMode="single" [(selection)]="categoriaSelecionada" styleClass="rd-arvore">
        <ng-template let-no pTemplate="default">
          <span>{{ no.label }}</span> <small class="rd-qtde">{{ no.data.modelos }}</small>
        </ng-template>
      </p-tree>
      <p class="rd-sem-categoria" *ngIf="!arvore.length">Nenhuma categoria ainda. Crie em "Categorias".</p>
    </section>

    <section class="rd-tabela">
      <div class="rd-filtros">
        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input type="text" pInputText placeholder="Buscar por título ou chave" [(ngModel)]="busca" aria-label="Buscar" />
        </span>
        <p-selectButton [options]="situacoes" [(ngModel)]="situacao" optionLabel="label" optionValue="value"></p-selectButton>
      </div>

      <p-table [value]="modelosFiltrados" [paginator]="modelosFiltrados.length > 15" [rows]="15" styleClass="p-datatable-sm" dataKey="id"
        [rowHover]="true">
        <ng-template pTemplate="header">
          <tr>
            <th>Modelo</th>
            <th style="width: 170px">Fonte</th>
            <th style="width: 120px">Situação</th>
            <th style="width: 80px">Versão</th>
            <th>Distribuição</th>
            <th [style.width]="podeExcluir ? '100px' : '60px'"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-m>
          <tr class="rd-linha" (dblclick)="abrirModelo(m)">
            <td>
              <div class="rd-modelo-titulo">{{ m.titulo }}</div>
              <div class="rd-modelo-meta">
                <code>{{ m.chave }}</code>
                <span *ngIf="m.categoriaId"> · {{ nomeCategoria(m.categoriaId) }}</span>
                <span *ngIf="m.alteradoPor"> · {{ m.alteradoPor }}</span>
                <span *ngIf="m.alteradoEm">, {{ m.alteradoEm | date: 'dd/MM HH:mm' }}</span>
                <span *ngIf="m.temRascunho" class="rd-rascunho"> · rascunho pendente</span>
              </div>
            </td>
            <td><code>{{ m.fonteChave }}</code></td>
            <td><span [class]="classeSituacao(m.situacao)">{{ rotuloSituacao(m.situacao) }}</span></td>
            <td>
              <strong *ngIf="m.versaoPublicada">v{{ m.versaoPublicada }}</strong>
              <span *ngIf="m.versaoPiloto" class="rd-piloto"> v{{ m.versaoPiloto }} piloto</span>
              <span *ngIf="!m.versaoPublicada && !m.versaoPiloto">—</span>
            </td>
            <td>
              <span class="rd-chip" *ngFor="let d of m.distribuicaoResumo">{{ d }}</span>
              <span *ngIf="!m.distribuicaoResumo?.length">—</span>
            </td>
            <td>
              <button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-rounded" aria-label="Abrir modelo" (click)="abrirModelo(m)"></button>
              <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger" aria-label="Excluir modelo"
                pTooltip="Excluir" tooltipPosition="left" *ngIf="podeExcluir" (click)="excluirModelo(m)"></button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6">Nenhum modelo aqui.</td>
          </tr>
        </ng-template>
      </p-table>
    </section>
  </div>

  <section class="rd-tabela" *ngIf="aba === 'fontes'">
    <div class="rd-filtros">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input type="text" pInputText placeholder="Buscar por título ou chave" [(ngModel)]="busca" aria-label="Buscar" />
      </span>
    </div>
    <p-table [value]="fontesFiltradas" styleClass="p-datatable-sm" dataKey="id" [rowHover]="true">
      <ng-template pTemplate="header">
        <tr>
          <th>Fonte</th>
          <th style="width: 200px">Rotina exigida</th>
          <th style="width: 100px">Versão</th>
          <th style="width: 150px">Usada por</th>
          <th [style.width]="podeExcluir ? '100px' : '60px'"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-f>
        <tr class="rd-linha" (dblclick)="abrirFonte(f)">
          <td>
            <div class="rd-modelo-titulo">{{ f.titulo }}</div>
            <div class="rd-modelo-meta">
              <code>{{ f.chave }}</code>
              <span *ngIf="f.alteradoPor"> · {{ f.alteradoPor }}</span>
              <span *ngIf="f.alteradoEm">, {{ f.alteradoEm | date: 'dd/MM HH:mm' }}</span>
              <span *ngIf="f.temRascunho" class="rd-rascunho"> · rascunho pendente</span>
            </div>
          </td>
          <td>{{ f.rotinaExigida || '—' }}</td>
          <td>{{ f.versaoAtual ? 'v' + f.versaoAtual : 'sem versão' }}</td>
          <td>{{ f.usadaPor }} {{ f.usadaPor === 1 ? 'modelo' : 'modelos' }}</td>
          <td>
            <button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-rounded" aria-label="Abrir fonte" (click)="abrirFonte(f)"></button>
            <span *ngIf="podeExcluir" tooltipPosition="left"
              [pTooltip]="f.usadaPor ? 'Usada por ' + f.usadaPor + (f.usadaPor === 1 ? ' modelo' : ' modelos') + ': exclua ou troque a fonte deles antes.' : 'Excluir'">
              <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger" aria-label="Excluir fonte"
                [disabled]="f.usadaPor > 0" (click)="excluirFonte(f)"></button>
            </span>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="5">Nenhuma fonte ainda. Crie uma ou importe um JRXML.</td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</div>

<p-dialog header="Novo modelo" [(visible)]="mostrarNovoModelo" [modal]="true" [style]="{ width: '560px' }">
  <div class="p-fluid rd-form">
    <label for="nm-fonte">Fonte</label>
    <p-dropdown inputId="nm-fonte" [options]="fontesModelo" [(ngModel)]="novoModelo.fonte" placeholder="Escolha uma fonte com versão salva"
      [filter]="true" appendTo="body" emptyMessage="Nenhuma fonte com versão salva. Crie ou importe uma fonte e salve a versão 1."
      emptyFilterMessage="Nenhuma fonte encontrada."></p-dropdown>
    <label for="nm-titulo">Título</label>
    <input id="nm-titulo" type="text" pInputText [(ngModel)]="novoModelo.titulo" (blur)="sugerirChave()" />
    <label for="nm-chave">Chave</label>
    <input id="nm-chave" type="text" pInputText [(ngModel)]="novoModelo.chave" placeholder="ex.: vendas-por-vendedor" />
    <label for="nm-categoria">Categoria</label>
    <p-dropdown inputId="nm-categoria" [options]="opcoesCategoria" [(ngModel)]="novoModelo.categoriaId" [showClear]="true" placeholder="Sem categoria"
      appendTo="body"></p-dropdown>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" (click)="mostrarNovoModelo = false"></button>
    <button pButton type="button" label="Criar e abrir" icon="pi pi-check" (click)="criarModelo()"></button>
  </ng-template>
</p-dialog>

<p-dialog header="Categorias" [(visible)]="mostrarCategorias" [modal]="true" [style]="{ width: '640px' }">
  <p-table [value]="opcoesCategoria" styleClass="p-datatable-sm" *ngIf="!categoriaEdicao">
    <ng-template pTemplate="header">
      <tr>
        <th>Categoria</th>
        <th style="width: 110px"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-op>
      <tr>
        <td>{{ op.label }}</td>
        <td>
          <button pButton type="button" icon="pi pi-pencil" class="p-button-text p-button-rounded" aria-label="Editar" *ngIf="podeEditarCategoria"
            (click)="editarCategoria(categoria(op.value))"></button>
          <button pButton type="button" icon="pi pi-trash" class="p-button-text p-button-rounded p-button-danger" aria-label="Excluir" *ngIf="podeExcluir"
            (click)="excluirCategoria(categoria(op.value))"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="2">Nenhuma categoria ainda.</td>
      </tr>
    </ng-template>
  </p-table>
  <div class="p-fluid rd-form" *ngIf="categoriaEdicao">
    <label for="cat-nome">Nome</label>
    <input id="cat-nome" type="text" pInputText [(ngModel)]="categoriaEdicao.nome" />
    <label for="cat-pai">Dentro de</label>
    <p-dropdown inputId="cat-pai" [options]="opcoesCategoria" [(ngModel)]="categoriaEdicao.pai" [showClear]="true" placeholder="Raiz" appendTo="body"></p-dropdown>
    <label for="cat-ordem">Ordem</label>
    <p-inputNumber inputId="cat-ordem" [(ngModel)]="categoriaEdicao.ordem" [useGrouping]="false"></p-inputNumber>
  </div>
  <ng-template pTemplate="footer">
    <ng-container *ngIf="!categoriaEdicao">
      <button pButton type="button" class="p-button-text" label="Fechar" (click)="mostrarCategorias = false"></button>
      <button pButton type="button" label="Nova categoria" icon="pi pi-plus" *ngIf="podeEditarCategoria" (click)="editarCategoria()"></button>
    </ng-container>
    <ng-container *ngIf="categoriaEdicao">
      <button pButton type="button" class="p-button-text" label="Voltar" (click)="categoriaEdicao = null"></button>
      <button pButton type="button" label="Salvar" icon="pi pi-check" (click)="salvarCategoria()"></button>
    </ng-container>
  </ng-template>
</p-dialog>
